import React, {useEffect, useState} from "react";
import { MdOutlineArrowBackIos } from "react-icons/md";

import WithUserData from "../../WithUserData";
import styles from "../../../TalentApplication/styles.module.css";
import {FaInstagram} from "react-icons/fa";
import Modal from "../../../utils/Modal";
import qs from "query-string";
import fetchJsonp from "fetch-jsonp";
import { EXCHANGE_TOKEN } from "../../WithUserData/queries";
import {useMutation} from "@apollo/client";
import Spinner from "../../../../assets/Spinner/Spinner";
import {Link} from "react-router-dom";

const ConnectContent = ({ history }) => {
    const [showVerifyModal, setShowVerifyModal] = useState(false)
    const [hasMediaAccess, setHasMediaAccess] = useState(false)
    const [ exchangeToken ] = useMutation(EXCHANGE_TOKEN)

    const redirectUri =
        window.location.origin + "/account/instagram/connect".replace("http://", "https://");
    const instagramAuthURL = `https://www.instagram.com/oauth/authorize`;

    const hashString = window.location.search.substr(1, window.location.search.indexOf("&state") - 1);


    useEffect(() => {
        getAuthenticateToken();
        getAccessToken();
    }, []);

    useEffect(() => {
        if(hasMediaAccess){

            history.push('/account/instagram/select-photos');
        }
    }, [hasMediaAccess])

    const getAccessToken = async () => {
        const hashString = window.location.search.substr(1, window.location.search.indexOf("&state") - 1);
        if (hashString.startsWith('code')) {
            setShowVerifyModal(true);
            const accessCode = hashString.substr(5);
            try {
                const response = await exchangeToken({
                    variables: {
                        code: accessCode,
                        redirectUri
                    },
                });
                let userAccessToken = response.data.exchangeToken;
                checkMediaAccess(userAccessToken);
            }
            catch (error) {
                console.log("Error exchanging token: ", error)
            }
        }
    };

    const checkMediaAccess = async (accessToken) => {
        //Remove any previously set instagram access token
        localStorage.removeItem('instagram_access_token');
        localStorage.setItem('instagram_access_token', accessToken);
        const queryString = qs.stringify({
            access_token: accessToken,
        });
        const body = await fetchJsonp(
            'https://graph.instagram.com/v21.0/me/media/?' + queryString
        ).then((res) => res.json())
            .catch (error => console.log(error));

        if (!body.hasOwnProperty('error')) {
            setHasMediaAccess(true);
        }
    };

    const getAuthenticateToken = () => {
        const hashString = window.location.search.substr(window.location.search.indexOf("state="));
        const authToken = hashString.substr(6);

        if (!window.localStorage.getItem("token")) {
            window.localStorage.setItem("token", authToken);
        }
    }
    return (
        <div className='w-full h-full flex flex-col px-2'>
            <div className="w-full h-16 flex justify-between items-center mt-6">
                <Link
                    to="/account/instagram"
                    className="ml-0 cursor-pointer w-24 py-2 border border-black text-gray-900 rounded-lg flex items-center mx-auto hover:bg-gray-200"
                >
                    <div className="w-10 flex items-center justify-center">
                        <MdOutlineArrowBackIos size={18} />
                    </div>
                    <span>Back</span>
                </Link>
                <div className="text-black text-2xl font-bold mr-10">Instagram</div>
            </div>


            <div className="flex flex-col pb-10 mt-6">
                <form
                    action={instagramAuthURL}
                    method="GET"
                    className='flex flex-col items-center'
                >
                    <input
                        type="hidden"
                        name="client_id"
                        value={process.env.REACT_APP_SCHMODEL_INSTAGRAM_APP_ID}
                    />
                    <input type="hidden" name="redirect_uri" value={redirectUri} />
                    <input
                        type="hidden"
                        name="scope"
                        value="instagram_business_basic"
                    />
                    <input type="hidden" name="response_type" value="code" />
                    <input
                        type="hidden"
                        name="state"
                        value={window.localStorage.getItem("token")}
                    />
                    <button
                        className="flex items-center bg-gray-300 text-black px-6 py-2 rounded-xl font-bold text-sm cursor-pointer mx-auto hover:bg-gray-400"
                    >
                        <FaInstagram className="mr-2" size={25} />
                        <div className="text-left">Connect to Instagram</div>
                    </button>

                    <div className='text-center m-10'>
                        You will need to make sure you allow Instagram's cookies and share your media with Schmodel.
                        <br />
                        <br />
                        Don’t worry, your data is safe in <br />
                        accordance with our Privacy Policy <br /> and Instagram’s Terms
                        of Business.
                    </div>
                    {hashString?.startsWith("error") && (
                        <div
                            style={{
                                color: "#e04344",
                                paddingLeft: 30,
                                fontSize: 14,
                                width: 300,
                            }}
                        >
                            <strong style={{ display: "inline" }}>Oops! </strong>
                            Instagram authorization failed.
                            <br /> Please click on Connect to Instagram, then make sure you accept Instagram's cookies,
                            and click 'Allow' to share your media with Schmodel.
                        </div>
                    )}
                    {showVerifyModal && (
                        <Modal
                            backgroundStyle={styles.ModalBackground}
                            modalContentStyle={styles.ModalContent}
                            showLogo={false}
                            showClose={false}
                            showFooter={false}
                        >
                            <h2 className={[styles.h2Modal, "text-black"]}>Verifying access</h2>
                            <p className={styles.pModal} style={{ display: "block", color: 'black' }}>
                                Please wait while we verify access <br />
                                to your Instagram profile and media.
                            </p>
                            <div className={styles.Loading}>
                                <Spinner color='black' />
                            </div>
                        </Modal>
                    )}
                </form>
            </div>
        </div>
    );
};


const InstagramConnect = ({history}) => {
    return (
        <WithUserData>
            {() => <ConnectContent history={history} />}
        </WithUserData>
    );
};

export default InstagramConnect;